<div (click)="toggleAll(accordionMain)" class="subscription-header title-medium" data-testid="subscriptionName">
  <span>

  {{ subscriptionName() }}
  </span>
  <div class="trailing-header">
    @if (!fullExtended) {

      <span class="material-symbols-rounded">keyboard_double_arrow_down</span>
    } @else {
      <span class="material-symbols-rounded">keyboard_double_arrow_up</span>

    }
  </div>
</div>

<cdk-accordion #accordionMain="cdkAccordion" id="eee" multi="true">
  @for (category of data()|keyvalue; track category; let index = $index) {


    <cdk-accordion-item #accordionItem="cdkAccordionItem"
                        class="example-accordion-item"
                        style="margin-bottom: 8px"
    >

      <div [attr.data-testid]="category.key" class="accordion-item-header header-level-1 title-medium"
           style="padding: 0"
           [ngClass]="accordionItem.expanded?'expanded':''" (click)="accordionItem.toggle()">
        <div style="padding: 14px 16px;line-height: 28px">
          **{{ category.key }}**
        </div>

        <div class="trailing-header" style="padding: 14px 16px"
             [style.background-color]="accordionItem.expanded ? 'var(--light-blue-80)' : ''">

                <span
                  class="material-symbols-rounded">{{ accordionItem.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</span>
        </div>
      </div>


      <div class="accordion-item-body" role="region"
           [style.display]="accordionItem.expanded ? '' : 'none'">
        @for (interval of category.value["intervals"]; track interval; let indexLevel2 = $index) {
          <cdk-accordion>

            <cdk-accordion-item #accordionItemLevel2="cdkAccordionItem"
                                class="example-accordion-item"
                                style="margin-top: 8px">

              <div (click)="accordionItemLevel2.toggle()" class="accordion-item-header header-level-2"
                   style="padding: 0"
                   [ngClass]="accordionItemLevel2.expanded?'expanded':''">

                <div style="padding: 14px 16px;line-height: 28px">
                  {{ interval["time"] }}
                </div>
                <div class="trailing-header" style="padding: 14px 16px;background: var(--secondary-container)">
                        <span
                          class="material-symbols-rounded">{{ accordionItemLevel2.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</span>
                </div>
              </div>


              <div class="accordion-item-body" role="region"
                   [style.display]="accordionItemLevel2.expanded ? '' : 'none'"
              >
                <div style="display: flex;align-items: stretch">
                  <div style="flex: 1">
                    <div class="connector-prise-row title-small">
                      <span>AC</span> <input [(ngModel)]="interval['ac']">
                    </div>

                    <div class="connector-prise-row title-small">
                      <span>DC</span> <input [(ngModel)]="interval['dc']">
                    </div>

                    <div class="connector-prise-row title-small">
                      <span>UFC</span> <input [(ngModel)]="interval['ufc']">
                    </div>
                  </div>

                  <div style="background: var(--secondary-container);width: 56px"></div>
                </div>

              </div>

            </cdk-accordion-item>

          </cdk-accordion>
        }

      </div>

    </cdk-accordion-item>


  }

</cdk-accordion>
